export const HEADER_IDS = {
  POINTS: 'perks',
  PURCHASE_AMOUNT: 'purchaseAmount',
};
